import PropTypes from 'prop-types';
import { fmt } from './formatters';

export function LigneCalcul({
  label,
  valeur,
  muted = false,
  strong = false,
  dividerTop = false,
  indent = false,
  highlight = false,
  info = false,
}) {
  return (
    <div
      className={[
        'grid grid-cols-[1fr_auto] items-start gap-3 py-0.5',
        dividerTop ? 'pt-2 mt-1 border-t border-gray-200' : '',
        highlight ? 'bg-green-50 rounded px-1' : '',
      ].join(' ')}
    >
      <span
        className={[
          'text-sm',
          indent ? 'pl-4' : '',
          info ? 'text-gray-400 italic' : muted ? 'text-gray-500' : 'text-gray-600',
          strong ? 'font-semibold text-gray-800' : '',
          highlight ? 'font-semibold text-green-800' : '',
        ].join(' ')}
      >
        {label}
      </span>
      <span
        className={[
          'text-sm text-right tabular-nums',
          info ? 'text-gray-400 italic' : muted ? 'text-gray-500' : 'text-gray-900',
          strong ? 'font-semibold text-gray-800' : 'font-medium',
          highlight ? 'font-bold text-green-700' : '',
        ].join(' ')}
      >
        {valeur === null || valeur === undefined || valeur === '' ? <span className="opacity-0">–</span> : valeur}
      </span>
    </div>
  );
}

LigneCalcul.propTypes = {
  label: PropTypes.string.isRequired,
  valeur: PropTypes.node,
  muted: PropTypes.bool,
  strong: PropTypes.bool,
  dividerTop: PropTypes.bool,
  indent: PropTypes.bool,
  highlight: PropTypes.bool,
  info: PropTypes.bool,
};

export function Sep({ color = 'border-gray-200' }) {
  return <div className={`border-t-2 ${color} my-3`} />;
}

Sep.propTypes = {
  color: PropTypes.string,
};

export function BlocResultat({ label, valeur, color = 'text-primary-600', sub = null }) {
  return (
    <div className="text-center mt-2">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{label}</p>
      <p className={`text-4xl font-bold ${color}`}>
        {fmt(valeur)}
        <span className="text-base text-gray-400 font-normal">/mois</span>
      </p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  );
}

BlocResultat.propTypes = {
  label: PropTypes.string.isRequired,
  valeur: PropTypes.number,
  color: PropTypes.string,
  sub: PropTypes.string,
};

export function BadgeSource({ source }) {
  if (source !== 'fallback') return null;
  return (
    <div className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-amber-100 border border-amber-300 px-2.5 py-1 text-xs font-medium text-amber-800">
      <span>⚠️</span>
      <span>Estimation forfaitaire (API URSSAF indisponible)</span>
    </div>
  );
}

BadgeSource.propTypes = {
  source: PropTypes.string,
};

export function StatusCard({ icon, title, titleColor = 'text-gray-700', borderColor, children }) {
  return (
    <div className={`bg-white rounded-xl shadow-card border-4 ${borderColor} p-6 flex flex-col h-full`}>
      <div className="mb-4 flex items-center gap-2">
        <span className="text-2xl">{icon}</span>
        <h3 className={`text-xl font-bold ${titleColor}`}>{title}</h3>
      </div>
      <div className="flex-grow">{children}</div>
    </div>
  );
}

StatusCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  borderColor: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
